import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { CTA_CLASS, JourneyCTA } from "./immersion/JourneyCTA";

export function MuteButton({ muted, onToggle }) {
  return (
    <button
      data-testid="audio-mute-button"
      data-muted={muted ? "true" : "false"}
      aria-pressed={muted}
      aria-label={muted ? "Unmute sound" : "Mute sound"}
      onClick={onToggle}
      className={`fixed right-6 top-6 z-[80] flex items-center gap-2 rounded-full border px-3 py-3 backdrop-blur-xl transition-colors duration-300 ${
        muted ? "border-[#7E57C2]/60 bg-[#7E57C2]/15 text-[#7E57C2]" : "border-[#B39DDB]/60 bg-white/70 text-[#2D1E3E] hover:border-[#7E57C2] hover:text-[#7E57C2]"
      }`}
    >
      {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      <span className="sr-only">{muted ? "Sound off" : "Sound on"}</span>
    </button>
  );
}

export function SeeButton({ onSee }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 3000);
    return () => clearTimeout(t);
  }, []);
  return (
    <JourneyCTA show={ready} testid="see-painting-cta">
      <button data-testid="see-painting-button" onClick={onSee} disabled={!ready} className={CTA_CLASS}>
        See the painting ✦
      </button>
    </JourneyCTA>
  );
}
